export enum CustomerSettingsComponents {
  'RoutePlanning' = 'RoutePlanning',
  'FieldReportingDashboard' = 'FieldReportingDashboard',
}

// hardcoded customerIds
export enum CustomerIds {
  'POWERLINES' = 3,
}
